import styled from 'styled-components';
import { isMobile, isTablet, WithBreakpointRange } from '@mews-commander/ui';
import { Container, getToken, Stack, withBreakpointRange, WithChildren } from '@optimus-web/core';

const GreyBackground = styled(Container)`
    background-color: ${getToken('paletteBrandNight25')};
`;

const FAQLayoutComponent: React.FC<WithBreakpointRange & WithChildren> = ({ children, breakpointRange }) => (
    <GreyBackground>
        <Container
            padding={[
                (isMobile(breakpointRange) && '300') || '900',
                (isMobile(breakpointRange) && '200') || (isTablet(breakpointRange) && '300') || '900',
            ]}
        >
            <Stack vertical spacing="300">
                {children}
            </Stack>
        </Container>
    </GreyBackground>
);

export const FAQLayout = withBreakpointRange(FAQLayoutComponent);
